/**it's a hack to store webpack media url generated at build inside a dictionnary
 * we can use the folder inside src as a "pool"
 * we can later retrieve an media url juste with the key (here the basename)
 */

/**this method list all assets and store their base name as key and build url as value */
function importAll(assets: __WebpackModuleApi.RequireContext) {
  let sfx: any = {};
  assets.keys().forEach((item) => {
    sfx[item.replace("./", "").replace(".wav", "")] = assets(item);
  });
  return sfx;
}

export const allSfx = importAll(
  /**path src/assets/sxf
   * regex for take all .wav and .mp3
   */
  require.context("../../assets/sfx/", false, /\.(wav|mp3)$/)
);
